/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { withDispatch, select } from '@wordpress/data';
import { compose } from '@wordpress/compose';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import BaseWrapper from '../../../components/base-wrapper';
import { updateBlockStyle } from './inline-styles';

const ALLOWED_BLOCKS = [ 'core/social-links' ];

const getInnerBlockTemplate = () => {
	return [
		[ 'core/image', {
			url: `${ window.gutenify_block_data.plugin_directory_url }assets/images/profile-pic.jpg`,
			align: 'center',
		} ],
		[ 'core/heading',
			{
				content: __( 'Jane Doe' ),
				level: 3,
				placeholder: __( 'Title' ),
				className: 'gutenify-team-member-block-name',
				textAlign: 'center',
			} ],
		[ 'core/heading',
			{
				content: __( 'Founder/ CEO' ),
				level: 4,
				placeholder: __( 'Degination' ),
				className: 'gutenify-team-member-block-degination',
				textAlign: 'center',
				// style: { typography: { textTransform: 'capitalize' } },
			} ],
		[ 'core/paragraph', {
			content: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet est massa. Sed enim massa, mattis at libero nec, bibendum ultricies augue.' ),
			placeholder: __( 'Bio of team member.' ),
			className: 'gutenify-team-member-block-bio',
			align: 'center',
		} ],
		[ 'core/social-links', {
			align: 'center',
			layout: {
				type: 'flex',
				justifyContent: 'center',
			},
		} ],
	];
};

const Edit = ( props ) => {
	const { isSelected, className, attributes } = props;
	const { layout } = attributes;
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );
	const wrapperClasses = classnames(
		className,
		`gutenify-team-member-${ layout }`
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props }>
				{ isSelected && <Inspector { ...props } /> }
				<InnerBlocks
					allowedBlocks={ ALLOWED_BLOCKS }
					template={ getInnerBlockTemplate() }
					templateLock="all"
					templateInsertUpdatesSelection={ false }
				/>
			</BaseWrapper>
		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'core/image' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.imageAlign } );
					}
					if ( 'core/heading' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { textAlign: template.titleAlign } );
					}
					if ( 'core/paragraph' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.titleAlign } );
					}
					if ( 'core/social-links' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							align: template.socialIconAlign,
							layout: {
								type: 'flex',
								justifyContent: template.socialIconAlign,
							},
						} );
					}
				} );
			},
		};
	} ),
] )( Edit );
